export const THEME = {
  color: {
    white: '#FFF',
    blue: '#0588CE',
    yellow: '#FBE21F',
    red: '#F8AFAF',
    black: '#1A1A1A',
  },
}

export const STORAGE_KEY = 'recruit-form.0.0.1'

/** ローカルストレージに保存しないフォーム項目 */
export const IGNORED_FORM_KEYS = [
  'question',
  'resumeFile',
  'skillSheetFile',
  'portfolioFile',
  'requestJobCategory',
  'companyName',
  'departmentName',
  'requestStartAt',
  'clientId',
  'resumeFile',
  'skillSheetFile',
  'portfolioFile',
  'acceptMailMagazine',
] as const

export type IgnoreSaveFormKey = typeof IGNORED_FORM_KEYS[number]
